export class AngularUtils {

  static hasBindingChanged(changeObj: { currentValue: any, previousValue: any }): boolean {
    return changeObj &&
      changeObj.currentValue &&
      !angular.equals(changeObj.currentValue, changeObj.previousValue);
  }

}
